export type HeaderUi = {
  orderNumber: string;
};

export const initialState: HeaderUi = {
  orderNumber: '',
};
